<ng-container *ngIf="embedded; else popupEditor" [ngTemplateOutlet]="editorContent"></ng-container>
<ng-template #popupEditor>
<default-popup-wrapper-component [displayMode]="'DISPLAY_MODE_XLARGE'" [globalPopup]="globalPopup" [title]="'candelarrules.edit' | translate" (onClose)="closePopup($event)">
    <ng-container *ngTemplateOutlet="editorContent"></ng-container>
</default-popup-wrapper-component>
</ng-template>
<ng-template #editorContent>
    <div class="control-exception-container">
        <div class="row">
            <div *ngIf="!embedded" class="pr-2 program-list-container" [ngClass]="{'open':(showList || activeControlException === null), 'is-hidden':(_laptopMode || _tabletMode || _mobileMode)}">
                <div class="header mt-1 mb-2">
                    <div class="search-container">
                        <div class="input-container">
                            <input type="search" class="search-field" (keyup.enter)="doSearch()" [(ngModel)]="currentActiveFilterQuery" placeholder="{{'treesearch.placeholder' | translate}}" />
                            <div class="search-buttons">
                                <i class="material-icons search-clear-btn" (click)="clearSearchQuery()" [ngClass]="{'active':hasSearchQuery()}">close</i>
                                <i class="material-icons" (click)="doSearch()">search</i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="program-list pr-2">
                    <div *ngIf="isLoadingControlExceptionList && !isAddingNewException" class="py-3 d-flex justify-content-center">
                        <div class="loader"></div>
                    </div>
                    <ng-container *ngIf="isAddingNewException">
                        <div class="program-item is-new is-selected">
                            <div class="name w-100 d-flex align-items-center">{{'candelarrules.new-exception-name' | translate}}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!isLoadingControlExceptionList">
                        <span *ngIf="controlExceptionList.length == 0 && !isAddingNewException">{{'candelarrules.no-rules-found' | translate}}</span>
                    </ng-container>
                    <ng-container *ngFor="let controlException of controlExceptionList; let index = index">
                        <div class="program-item" *ngIf="!controlException.isHidden || controlException.isSelected" (click)="getControlException(controlException.id)" [ngClass]="{'is-selected':controlException.isSelected}">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="name w-100 d-flex align-items-center"><span class="color" [ngStyle]="{ 'background-color': controlException.color}" *ngIf="controlException.color"></span>{{controlException.name}}</div>
                                <div class="d-flex align-items-center justify-content-end" *ngIf="canEditExceptionProgram()">
                                    <i class="material-icons p-0 dropdown-icon"
                                       (click)="toggleOptionsDropdown(controlException,$event)"
                                    >more_vert</i>
                                    <div class="dropdown" [ngClass]="{'show':controlException.showOptionsDropdown, 'dropup':(controlExceptionList.length > 7 && index > controlExceptionList.length-4)}">
                                        <div class="dropdown-menu smart-selection-dropdown dropdown-menu-right">
                                            <ul class="mb-0">
                                                <li class="d-flex align-items-center p-1" (click)="copyProgram($event)">
                                                    <i class="material-icons p-0 mr-1">content_copy</i>
                                                    <span>{{'control-program.copy-program-btn' | translate}}</span>
                                                </li>
                                                <li class="d-flex align-items-center p-1" (click)="deleteActiveControlException()">
                                                    <i class="material-icons p-0 mr-1">delete</i>
                                                    <span>{{'control-program.remove-control-program' | translate}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <i class="material-icons p-0">keyboard_arrow_right</i>
                                </div>
                            </div>
                            <div class="info w-100">
                                <ul>
                                    <li *ngIf="controlException.usedBy"><span>{{totalDimgroepsText(controlException.usedBy)}}</span></li>
                                    <li *ngIf="controlException.controlProgram && controlException.controlProgram.name"><span>{{'candelarrules.control-program-label' | translate}}: {{controlException.controlProgram.name}}</span></li>
                                </ul>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="add-btn-container">
                    <lumi-button (onClick)="addException()"
                                 [disabled]="disableAddExceptionButton"
                                 [size]="'small'"
                                 [rank]="'primary'"
                                 [label]="'candelarrules.add-btn' | translate"
                                 [icon]="'add_circle'">
                    </lumi-button>
                </div>
                <div *ngIf="(_laptopMode || _tabletMode || _mobileMode) && activeControlException !== null" class="mobile-expand-icon" (click)="toggleArticleNavigation()"><i class="material-icons">menu_open</i></div>
            </div>
            <div class="pl-5 pr-3 program-details-container" *ngIf="isAddingNewException || activeControlException || isLoadingControlException" (click)="toggleArticleNavigation(true)">
                <div class="py-3 d-flex justify-content-center" *ngIf="isLoadingControlException">
                    <div class="loader"></div>
                </div>
                <div *ngIf="!isLoadingControlException">
                    <div class="program-details-header">
                        <div class="row">
                            <div class="col-12">
                                <label for="field-name" class="field-label">{{'control-program.label-name' | translate}}</label>
                                <div class="d-flex align-items-center">
                                    <input *ngIf="embedded" type="color" class="rule-color-input" [(ngModel)]="activeControlException.color" (ngModelChange)="selectColor()" [disabled]="!canEditExceptionProgram()" [attr.aria-label]="'control-program-v2.settings.color' | translate">
                                    <ngx-colors *ngIf="!embedded" ngx-colors-trigger
                                                [(ngModel)]="activeControlException.color"
                                                (ngModelChange)="selectColor()"
                                                [hideTextInput]="true"
                                                [disableControl]="false"
                                                [hideColorPicker]="false"
                                                [colorPickerControls]="'no-alpha'"
                                                [palette]="availableColorPallet"
                                                [disabled]="false">
                                    </ngx-colors>
                                    <div class="ml-2 w-100">
                                        <input type="text" [(ngModel)]="activeControlException.name" [disabled]="!canEditExceptionProgram()" [attr.placeholder]="isAddingNewException ? ('candelarrules.new-exception-name' | translate) : ('control-program.program-name-placeholder' | translate)" (ngModelChange)="checkForError()" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="program-details-inner mt-3 mb-2">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-4">{{'candelarrules.control-program-label' | translate}}</div>
                                    <div class="col-8">
                                        <div class="loader" *ngIf="isLoadingControlProgramList"></div>
                                        <lumi-select class="lumi-select-field" *ngIf="!isLoadingControlProgramList"
                                                     [options]="controlProgramsOptions"
                                                     [showOptionFilter]="true"
                                                     [style.width]="'80%'"
                                                     [selectedOptions]="getSelect('control-program')"
                                                     (onOptionsSelect)="changeSelect('control-program',$event)">
                                        </lumi-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">{{'candelarrules.dimgroeps-label' | translate}}</div>
                                    <div class="col-8">
                                        <div class="loader" *ngIf="isLoadingDimgroepList"></div>
                                        <lumi-select class="lumi-select-field" *ngIf="!isLoadingDimgroepList"
                                                     [options]="dimgroepOptions"
                                                     [showOptionFilter]="true"
                                                     [multi]="true"
                                                     [style.width]="'80%'"
                                                     [selectedOptions]="getSelect('dimgroep')"
                                                     (onOptionsSelect)="changeSelect('dimgroep',$event)">
                                        </lumi-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">{{'candelarrules.start-date-label' | translate}}</div>
                                    <div class="col-8">
                                        <div class="d-flex flex-wrap">
                                            <date-input [inputType]="'date'"
                                                        [allowClear]="false"
                                                        [initialValue]="activeControlException.startDate"
                                                        (onDateChanged)="changeDate('start',$event)"
                                            ></date-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">{{'candelarrules.end-date-label' | translate}}</div>
                                    <div class="col-8">
                                        <div class="d-flex flex-wrap">
                                            <date-input [inputType]="'date'"
                                                        [allowClear]="false"
                                                        [initialValue]="activeControlException.endDate"
                                                        (onDateChanged)="changeDate('end',$event)"
                                            ></date-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="program-details-footer">
                        <div class="row">
                            <div class="col-12 col-lg-9 dates align-self-end">
                                <span *ngIf="!isAddingNewException" class="sumup" [innerHTML]="textualSumup"></span>
                            </div>
                            <div class="col-12 col-lg-3 text-right" *ngIf="canEditExceptionProgram()">
                                <div class="d-flex align-items-center justify-content-end">
                                    <div class="save-success mr-2 d-flex align-items-center" [class.show]="saveSuccess">
                                        <i class="material-icons m-0 p-0 mr-1">check_circle_outline</i> <span>{{'dimming.savetitle' | translate}}</span>
                                    </div>
                                    <lumi-button (onClick)="saveException()"
                                                 [disabled]="hasFormError || saving"
                                                 [size]="'small'"
                                                 [rank]="'primary'"
                                                 [label]="'candelarrules.save-btn' | translate">
                                    </lumi-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
